import { Box, Stack, Typography } from '@mui/material';

export function FaceOverlayLegend() {
    const items = [
        {
            color: 'error.main',
            label: 'Hard failure (no face / partial / very blurry / multiple)',
        },
        {
            color: 'warning.main',
            label: 'Soft warning (occluded / low sharpness / dark / low similarity)',
        },
        { color: 'success.main', label: 'Passed / no issues' },
        { color: 'text.disabled', label: 'No diagnostics reason data' },
        { color: 'info.main', label: 'Reference face (informational)' },
        { color: '#4caf50', label: 'Landmark dot' },
    ] as const;

    return (
        <Stack gap={0.75}>
            {items.map(({ color, label }) => (
                <Stack key={label} direction="row" gap={1} alignItems="center">
                    <Box
                        sx={{
                            width: 14,
                            height: 14,
                            borderRadius:
                                label === 'Landmark dot' ? '50%' : 0.5,
                            bgcolor: color,
                            flexShrink: 0,
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {label}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
}
